module.exports = __webpack_public_path__ + "img/Mudah@3x.40cbe7d3.png";